import { render } from "./LeftMenuPanel.vue?vue&type=template&id=0ec33b58&scoped=true&ts=true"
import script from "./LeftMenuPanel.vue?vue&type=script&lang=ts"
export * from "./LeftMenuPanel.vue?vue&type=script&lang=ts"

import "./LeftMenuPanel.vue?vue&type=style&index=0&id=0ec33b58&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec33b58"]])

export default __exports__